import cx from "classnames";
import React, { type HTMLAttributes, useEffect, useRef } from "react";
import { Helmet } from "react-helmet";
import * as styles from "./DangerousHTML.module.scss";

interface Props extends HTMLAttributes<HTMLDivElement> {
	html: string;
}

const Component: React.FC<Props> = ({ html, className, ...rest }) => {
	const ref = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (!html || !ref.current) return;

		const htmlString = document.createRange().createContextualFragment(html);
		ref.current.innerHTML = "";
		ref.current.appendChild(htmlString);
	}, [html]);

	return (
		<>
			<Helmet>
				{/* HACK: Get pym resized embedded tools loading correctly */}
				<script src="https://pym.nprapps.org/pym-loader.v1.min.js" />
			</Helmet>
			<div ref={ref} {...rest} className={cx(styles.component, className)} />
		</>
	);
};

export const DangerousHTML = React.memo(Component);
